<template>
  <div class="popup-container" id="popup-container">
    <v-toolbar dark color="primary">
      <v-toolbar-title class="heading-title">
        Add Question
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn fab x-small class="close" @click="closePanel">
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container class="assetbar">
      <v-row>
        <v-col md="12">
          <v-form>
          <v-select
              :items="questionTypeOptions"
              v-model="question.type"
              item-value="id"
              item-text="name"
              label="Question Type"
              filled
              attach
              @change="showQuestionPanel()"
              >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Select question type</span>
                </v-tooltip>
              </template>
            </v-select>
          <v-container v-if="isSingleChoice" style="padding:0px !important">
            <v-text-field
              :error-messages="messages.question"
              v-model="question.question"
              label="Question"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter test question</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <h3>Answers</h3>
            <v-text-field
              :error-messages="messages.a"
              v-model="question.a"
              label="Answer A"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option A</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.b"
              v-model="question.b"
              label="Answer B"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option B</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.c"
              v-model="question.c"
              label="Answer C"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option C</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.d"
              v-model="question.d"
              label="Answer D"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option D</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <h3>Please select the correct answer</h3>
            <v-btn-toggle
              v-model="question.correct_answer"
              :error-messages="messages.correct_answer"
            >
              <v-btn v-if="question.a" value="a">A</v-btn>
              <v-btn v-if="question.b" value="b">B</v-btn>
              <v-btn v-if="question.c" value="c">C</v-btn>
              <v-btn v-if="question.d" value="d">D</v-btn>
            </v-btn-toggle>
            <p v-if="messages.correct_answer" class="pt-5"><span style="color:red;">Select a correct Answer</span></p>
          </v-container>
          <v-container v-if="isFillInTheBlank" style="padding:0px !important">
            <v-text-field
              :error-messages="messages.question"
              v-model="question.question"
              label="Question"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter test question</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <h3>Answers</h3>
            <v-text-field
              :error-messages="messages.a"
              v-model="question.a"
              label="Answer A"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option A</span>
              </v-tooltip>
            </template>
            </v-text-field>
          </v-container>
          <v-container v-if="isMultiChoice" style="padding:0px !important">
            <v-text-field
              :error-messages="messages.question"
              v-model="question.question"
              label="Question"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter test question</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <h3>Answers</h3>
            <v-text-field
              :error-messages="messages.a"
              v-model="question.a"
              label="Answer A"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option A</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.b"
              v-model="question.b"
              label="Answer B"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter option B</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.c"
              v-model="question.c"
              label="Answer C"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option C</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.d"
              v-model="question.d"
              label="Answer D"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option D</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.e"
              v-model="question.e"
              label="Answer E"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option E</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.f"
              v-model="question.f"
              label="Answer F"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option F</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.G"
              v-model="question.g"
              label="Answer G"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option G</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.h"
              v-model="question.h"
              label="Answer H"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option H</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.i"
              v-model="question.i"
              label="Answer I"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option I</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.j"
              v-model="question.j"
              label="Answer J"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter option J</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <h3>Please select the correct answers</h3>
            <v-btn-toggle
              v-model="question.correct_answer"
              :error-messages="messages.correct_answer"
              multiple

            >
              <v-btn v-if="question.a" value="a">A</v-btn>
              <v-btn v-if="question.b" value="b">B</v-btn>
              <v-btn v-if="question.c" value="c">C</v-btn>
              <v-btn v-if="question.d" value="d">D</v-btn>
              <v-btn v-if="question.e" value="e">E</v-btn>
              <v-btn v-if="question.f" value="f">F</v-btn>
              <v-btn v-if="question.g" value="g">G</v-btn>
              <v-btn v-if="question.h" value="h">H</v-btn>
              <v-btn v-if="question.i" value="i">I</v-btn>
              <v-btn v-if="question.j" value="j">J</v-btn>
            </v-btn-toggle>
            <v-label :error-messages="messages.correct_answer"></v-label>
            <p v-if="messages.correct_answer" class="pt-5"><span style="color:red;">The correct answer must be at least 2 options</span></p>
          </v-container>
          <v-container v-if="isAssociation" style="padding:0px !important">
            <v-text-field
              :error-messages="messages.question"
              v-model="question.question"
              label="Question"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter test question</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <h3>Association Labels</h3>
            <v-text-field
              :error-messages="messages.a"
              v-model="question.a"
              label="Label A"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter Label A</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.b"
              v-model="question.b"
              label="Label B"
              type="text"
              filled
            >
            <template slot="append-outer">
              <v-tooltip left>
               <template v-slot:activator="{on}">
                <v-icon v-on="on">fa fa-question</v-icon>
               </template>
               <span>Enter label B</span>
              </v-tooltip>
            </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.c"
              v-model="question.c"
              label="Label C"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter label C</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.d"
              v-model="question.d"
              label="Label D"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter label D</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.e"
              v-model="question.e"
              label="Label E"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter label E</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <h3>Association Options</h3>
            <v-text-field
              :error-messages="messages.f"
              v-model="question.f"
              label="Answer A"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter answer A</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.g"
              v-model="question.g"
              label="Answer B"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter answer B</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.h"
              v-model="question.h"
              label="Answer C"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter answer C</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.i"
              v-model="question.i"
              label="Answer D"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter answer D</span>
                </v-tooltip>
              </template>
            </v-text-field>
            <v-text-field
              :error-messages="messages.j"
              v-model="question.j"
              label="Answer E"
              type="text"
              filled
            >
              <template slot="append-outer">
                <v-tooltip left>
                 <template v-slot:activator="{on}">
                  <v-icon v-on="on">fa fa-question</v-icon>
                 </template>
                 <span>Enter answer D</span>
                </v-tooltip>
              </template>
            </v-text-field>
          </v-container>
          <v-switch 
              v-model="question.core"
              class="input_switch"
            >
            <template v-slot:label>
              <div><strong class="grey800--text">Core Question</strong></div>
              <div class="ml-5 mb-2">  
                  <v-tooltip right>
                   <template v-slot:activator="{on}">
                    <v-icon v-on="on">fa fa-question</v-icon>
                   </template>
                   <span>Selecting a question as 'Core' will ensure that it is asked regardless<br/> of question randonmisation being enabled. Use this to ensure <br/>key questions are covered in your tests.</span>
                  </v-tooltip>
              </div>
            </template>
              
            </v-switch>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
    <v-footer :absolute="this.isFillInTheBlank" height="68">
      <v-flex text-right>
        <v-btn v-if="!loading" color="grey300" class="cancel-button" @click="closePanel">Cancel</v-btn>
        <v-btn v-if="loading" color="primary" loading></v-btn>
        <v-btn v-else color="dark-blue" class="ml-4 add-course-button" @click="addQuestion">Add Question</v-btn>
      </v-flex>
    </v-footer>
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js";
import testAPI from "@/api/test.js";
export default {
  name: "CreateTest",
  components: {},
  props: {
    id: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      question: {},
      answers: {},
      messages: {},
      loading: false,
      successMessage: "Question has been added",
      errorMessage: "Oops something went wrong",
      questionTypeOptions: [
                    {
                        id: 1,
                        name: "Single Choice"
                    },
                    {
                        id: 2,
                        name: "Fill in the Blank"
                    },
                    {
                        id: 3,
                        name: "Multiple Choice"
                    },
                    {
                        id: 4,
                        name: "Association"
                    }
                    
                ],
      isSingleChoice: false,
      isFillInTheBlank: false,
      isMultiChoice: false,
      isAssociation: false
    };
  },
  computed: {},
  mounted() {
    this.showQuestionPanel();
  },
  methods: {
    closePanel() {
      this.$emit("closePanel");
    },
    addQuestion() {
      this.loading = true;
      if(this.question.type==2)
        testAPI.createFillQuestion(this.question, this.id)
        .then(() => {
          this.closePanel();
          EventBus.$emit("QUESTIONS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
      else if(this.question.type==3)
        testAPI.createMultiChoiceQuestion(this.question, this.id)
        .then(() => {
          this.closePanel();
          EventBus.$emit("QUESTIONS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
      else if(this.question.type==4)
        testAPI.createAssociationQuestion(this.question, this.id)
        .then(() => {
          this.closePanel();
          EventBus.$emit("QUESTIONS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          //this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          if(this.messages.f=='The f field is required.') {
            this.messages.f = "The association of label A is required."
          }
          if(this.messages.g=='The g field is required.') {
            this.messages.g = "The association of label B is required."
          }
          if(this.messages.h=='The h field is required when c is present.') {
            this.messages.h = "The association of label C is required."
          }
          if(this.messages.i=='The i field is required when d is present.') {
            this.messages.i = "The association of label D is required."
            this.loading = false;
          }
          if(this.messages.j=='The j field is required when e is present.') {
            this.messages.j = "The association of label E is required."
            this.loading = false;
          }
          this.loading = false;
        });
      else
      testAPI.createQuestion(this.question, this.id)
        .then(() => {
          this.closePanel();
          EventBus.$emit("QUESTIONS_UPDATED", this.params);
          this.$snotify.success(this.successMessage);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        })
        .catch(err => {
          this.valid = false;
          this.$snotify.error(this.errorMessage);
          this.messages = this.$gf.errorResponse(err);
          this.loading = false;
          setTimeout(() => {
                this.$gf.removeBackdrop();
            },300);
        });
    },
    showQuestionPanel() {
      let type = this.question.type;
      this.question=[];
      this.question.type= type;
      if(this.question.type==4) {
        this.isAssociation = true;
        this.isSingleChoice = false;
        this.isFillInTheBlank = false;
        this.isMultiChoice = false;
      } else if(this.question.type==1) {
        this.isAssociation = false;
        this.isSingleChoice = true;
        this.isFillInTheBlank = false;
        this.isMultiChoice = false;
      } else if(this.question.type==2) {
        this.isAssociation = false;
        this.isFillInTheBlank = true;
        this.isSingleChoice = false;
        this.isMultiChoice = false;
      } else if(this.question.type==3) {
        this.isAssociation = false;
        this.isMultiChoice = true;
        this.isSingleChoice = false;
        this.isFillInTheBlank = false;
      } else {
        this.isAssociation = false;
        this.isSingleChoice = true;
        this.isFillInTheBlank = false;
        this.isMultiChoice = false;
      }
    }
  }
};
</script>
